export const transferSteps = {
  transferStepsBeneficiary: "对方账户",
  transferStepsAmount: "金额",
  transferStepsTransfer: "转账",
  transferStepsError: "转账失败",
  transferStepsErrorDesc_1: "您的转账失败,请检查您的数据或联系支持。",
  transferStepsSuccess: "转账成功",
  transferStepsSuccessMessage: "您的转账已成功处理。",
  transferStepsNext: "下一步",
  transferStepsConfirm: "确认",
  transferStepsBack: "返回",
  transferStepsCancel: "取消",

  // Content step 1,
  transferStepsSelectContact: "选择联系人",
  transferStepsSelectContactOption: "请选择一个联系人",
  transferSteps_loading: "加载联系人...",
  transferSteps_loadingError: "加载联系人失败",

  // Content step 2,
  transferStepsTransferAmount: "输入要转账的金额",
  transferStepsTransferAmountInput: "输入金额",
  transferStepsAmountError: "金额无效",
  transferStepsAmountError2: "余额不足",

  // Content step 3,
  transferSteps_3_Confirm: "转账确认",
  transferSteps_3_Beneficiary: "对方账户 ",
  transferSteps_3_Amount: "金额",
};
